import 'vite/modulepreload-polyfill';
import * as Sentry from '@sentry/browser';
import { installCustomEventValidator } from '@/events/CustomEventRegistry';
import '../components';
import '../features';
import '../features/not-found/NotFoundPage';
import '../features/user/LoginPage';
import './App';

installCustomEventValidator();

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	enabled: import.meta.env.PROD,
	environment: import.meta.env.MODE,
	release: import.meta.env.VITE_APP_VERSION,
	tracesSampleRate: 0.2,
});